module.exports = __webpack_public_path__ + "static/media/billing.7557e70b.jpg";